import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/like.svg';

export const IconLike = createIconComponent(Icon);
